import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { ROUTES } from '@constants/routes';
import { ExperimentationService } from '@services/experimentation.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PurchasedGuard  {
	constructor(
		private readonly session: QuoteSessionQuery,
		private readonly router: Router,
		private readonly experimentationService: ExperimentationService
	) { }

	async canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Promise<boolean | UrlTree> {
		return firstValueFrom(this.session.quoteDetailsState$())
			.then(async (quoteDetails) => {
				await this.experimentationService.initializeClient();

				if (quoteDetails.purchaseSucceeded) {

					return this.router.parseUrl(ROUTES.CONGRATULATIONS);
				}

				return true;
			});
	}
}
